

















































import {
  defineComponent,
  ref,
} from '@vue/composition-api';

import {
  deleteItemGroup,
  getItemGroups,
} from '@/api/index';
import categoryOption from '@/table/Store/category';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import StickyFooterActionBar from '@/components/StickyFooterActionBar.vue';
import CommonModalWithMaterialTypeEditor from '@/components/Store/CommonModalWithMaterialTypeEditor.vue';

const Category = defineComponent({
  components: {
    CommonModalWithPreset,
    StickyFooterActionBar,
    CommonModalWithMaterialTypeEditor,
  },
  // props: {},
  setup() {
    const refetchQuery = ref(false);
    const total = ref(0);
    const editMaterialTypeModal = ref(null);
    const deleteMaterialTypeModal = ref(null);

    async function deleteMaterialTypeAction(id: number) {
      await deleteItemGroup(id);
      refetchQuery.value = true;
    }

    function handlerTableFetched(data: any) {
      total.value = data.total;
    }

    return {
      refetchQuery,
      getItemGroups,
      categoryOption,

      editMaterialTypeModal,
      deleteMaterialTypeModal,

      deleteMaterialTypeAction,

      total,
      handlerTableFetched,
    };
  },
});

export default Category;
